/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
import geoRouter from '@/app/geo/router.js'
import cashflowRouter from '@/app/cashflow/router.js'
import kpuRouter from '@/app/bsg/kpu/router.js'
import gradeControlRouter from '@/app/geo/gradecontrol/router.js'
import abcRouter from '@/app/abc/router.js'
import mrmrRouter from '@/app/geo/MRMR/router.js'
import drillingRouter from '@/app/drilling/router.js'
import decarbonizationRouter from '@/app/bsg/decarbonization/router.js'
import AuthService from '@/app/shared/services/authentication/auth.service';
import featureFlagsService from '@/app/shared/services/featureFlagsService.js'

const authService = new AuthService();


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      meta: {
        requireAuth: true
      },
      children: [
        // =============================================================================
        // App Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./app/Home.vue'),
          meta: {
            requireAuth: true,
            pageTitle: 'Home',
            i18n: 'Home'
          }
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import('@/views/pages/Logout.vue')
        },
        {
          path: '/bsg',
          name: 'BSG',
          component: () => import('./app/bsg/index.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/', i18n: 'Home' },
              { title: 'BSG', active: true, i18n: 'BSG.Title' }
            ],
            pageTitle: 'BSG',
            i18n: 'BSG.Title',
            rule: 'editor',
            requireAuth: true,
            requireRoles: [
              'CashflowReaders',
              'CashflowWriter',
              'DecarbonizationReaders',
              'DecarbonizationCollaborators',
              'KPUReaders',
              'KPUCollaborators',
              'Admin'
            ]
          }
        },
        ...cashflowRouter,
        ...kpuRouter,
        ...geoRouter,
        ...mrmrRouter,
        ...gradeControlRouter,
        ...abcRouter,
        ...drillingRouter,
        ...decarbonizationRouter
      ]
    },
       
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/pages/unauthorized-401',
          name: 'page-unauthorized-401',
          component: () => import('@/views/pages/Error401.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})


router.afterEach(() => {
})

router.beforeEach((to, from, next) => {
  
  if (to.matched.some(record => record.meta.requireAuth)) {
    // Ensure MSAL is initialized before checking authentication
    authService.initialize().then(() => {
      if (to.meta.requireRoles === undefined) {
        next()
      } 
      else if (!authService.checkRoles(to.meta.requireRoles)) {
        next({
          path: '/pages/unauthorized-401'
        })
      }
      else if (!featureFlagsService.isEnabled(to.meta.featureFlag)) {
        next({
          path: '/pages/not-found-404'
        })
      }
      else {
        next()
      }
    }).catch(error => {
      console.error('MSAL initialization error in route guard:', error);
      // Redirect to login or error page
      authService.loginRedirect();
    });
  } 
  else {
    next() // make sure to always call next()!
  }
})

export default router
